import { Icon, IconProps } from ".";

export const Dots = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M6.47314 15.8496H11.8065V21.1829H6.47314V15.8496Z" />
        <path d="M15.8065 15.8496H21.1398V21.1829H15.8065V15.8496Z" />
        <path d="M25.1398 15.8496H30.4731V21.1829H25.1398V15.8496Z" />
      </>
    </Icon>
  );
};
